import { render, staticRenderFns } from "./NotificacionResolucionForm.vue?vue&type=template&id=8f140e68"
import script from "./NotificacionResolucionForm.vue?vue&type=script&lang=js"
export * from "./NotificacionResolucionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports